import { RenderNode, documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, Document, INLINES } from '@contentful/rich-text-types';
import { getHtmlElementWithProps } from './dataHelper';

const customRenderFunctions: RenderNode = {
    [BLOCKS.HEADING_2]: (node, children): JSX.Element => {
        const elementDetails = getHtmlElementWithProps(node, children);

        return <h2 {...elementDetails.props}>{elementDetails.child}</h2>;
    },
    [INLINES.HYPERLINK]: (node, children): JSX.Element => {
        const isInternalLink = node.data.uri.includes('carmax.com') || node.data.uri.startsWith('#');
        const target = isInternalLink ? '' : '_blank';
        const rel = isInternalLink ? '' : 'noreferrer';
        return (
            <a href={node.data.uri} target={target} rel={rel}>
                {children}
            </a>
        );
    },
};

const renderText = (text: string) => {
    return text.split('\n').reduce((children: any, textSegment: string, index: number) => {
        return [...children, index > 0 && <br key={`${index}-br`} />, textSegment];
    }, []);
};

export const getKmxDocumentToReactComponents = (richText: Document) =>
    documentToReactComponents(richText, {
        renderNode: customRenderFunctions,
        renderText,
    });
